module.exports = __webpack_public_path__ + "static/media/browserconfig.293dd5c6.xml";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/browserconfig.xml
// module id = 93
// module chunks = 0